export default __webpack_public_path__ + "static/media/darkPurpleArgo.d40701de.svg";